import { Injectable } from "@angular/core";
import { Cryptocoin } from "@models/asset/cryptocoins/currencies/cryptocoin";
import { SocketService } from "../socket.service";
import { DestructorService } from "@core-services/destructor.service";
import { TranslationService } from "@core-services/translation.service";
import { AssetService } from "./asset.service";
import { InitService } from "@core-services/init.service";
import { debug } from "@helpers/debug";

@Injectable({
	providedIn: "root"
})
export class CryptocoinService extends AssetService<Cryptocoin> {
	public constructor(
		protected initService: InitService,
		protected socketService: SocketService,
		protected translationService: TranslationService,
		protected destructor: DestructorService
	) {
		super(initService, destructor, translationService, socketService, "CryptocoinService");
	}

	public logoUrl(item: Cryptocoin, grayVersion: boolean = false): string {
		let url = "assets/images/logos/";

		if (grayVersion) {
			url += "coins/" + item.getSymbol(true) + "-grey-half-transparent";
		} else {
			url += "coins/coin-" + item.getSymbol(true);
		}

		return url;
	}

	public getTradableToolTip(useCase: string, coin: Cryptocoin, isActionButton: boolean): string {
		if (!coin.isWithdrawActive() && useCase === "send") {
			return "action_send_inactive_tooltip";
		}
		if (!coin.isDepositActive() && useCase === "deposit") {
			return "action_deposit_tooltip";
		}
		return super.getTradableToolTip(useCase, coin, isActionButton);
	}

	public startSockets(): void {
		if (debug) {
			console.log("[DEBUG]: listen to coin updates");
		}

		const priceRoom = {
			room: "cryptocoin_prices",
			collection: "cryptocoins",
			type: Cryptocoin,
			isPrivate: false
		};
		const assetRoom = {
			room: "cryptocoins",
			collection: "cryptocoins",
			type: Cryptocoin,
			isPrivate: false
		};
		this.initSockets(priceRoom, assetRoom);
	}

	public getItemsByIdsList(idList: string[]): Cryptocoin[] {
		return idList.map((id) => this.getItemById(id));
	}
}
